export const WwexEditIcon = () => (
  <svg fill='currentColor' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2.99998 12.7487H3.841L10.6654 5.9243L9.82437 5.08328L2.99998 11.9077V12.7487ZM2 13.7487V11.4923L11.5 2L13.7384 4.27945L4.25638 13.7487H2ZM10.2375 5.51117L9.82437 5.08328L10.6654 5.9243L10.2375 5.51117Z' />
  </svg>
);
